import { customNavigate } from './navigate'
import { LOCALE } from '@foxrenderfarm/internals'

export class LocaleClass {
  static getCurrentLocaleFromPathName(path?: string) {
    if (path) {
      return Object.values(LOCALE).find((locale) => path.includes(`/${locale}/`))
    } else if (typeof window !== 'undefined') {
      const pathname = window.location.pathname
      const currentLocale = Object.values(LOCALE).find((locale) => pathname.includes(`/${locale}/`))
      return currentLocale
    }
  }

  static getCurrentLocaleName(path: string) {
    const currentLocale = this.getCurrentLocaleFromPathName(path)
    return currentLocale ? currentLocale : LOCALE.EN
  }

  static getPathWithoutLocale() {
    if (typeof window !== 'undefined') {
      const path = `${window.location.pathname}${window.location.search}`
      const currentLocale = this.getCurrentLocaleFromPathName()
      if (currentLocale) {
        return path.slice(3)
      }
      return path
    }
  }

  static changeLocale(locale: LOCALE) {
    const path = this.getPathWithoutLocale()
    path && customNavigate(path, locale)
  }

  static isEqualLocale(locale: LOCALE, lang: LOCALE) {
    return locale === lang
  }
  static isIncludesLocales(locale: LOCALE, langs: LOCALE[]) {
    return langs.some((lang) => locale === lang)
  }
}
